/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=fad5cae2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=fad5cae2&lang=scss&scoped=true"

import exportComponent from "/Users/kaopuai/rzd-project/rzd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad5cae2"]])

export default __exports__